/**
 * Classe de view para a funcionalidade de permissão de grupos de usuário.
 * @author: Adalto Junior adaltojunior@sagaranatech.com
 * Date: 17/09/13
 * Time: 15:48
 */

App.Views.GroupPermissions = {

    renderFilterPermissions: function () {

        var error                    = null,
            filterPermissions        = null,
            keyLabelFilter           = 'Greenmile.GroupPermissions.filterPermissions',
            keyLabelFormatted        = '',
            sectionFilterPermissions = null;

        try {

            sectionFilterPermissions = document.createElement('div');
            sectionFilterPermissions.id = 'containerFilterPermissions';

            keyLabelFormatted = Monet.I18n.getResourcesByKey(keyLabelFilter);

            filterPermissions = new Greenmile.GroupPermissions.FilterPermissions();

            filterPermissions.setId('searchPermissions');
            filterPermissions.setTextLabel(keyLabelFormatted);

            sectionFilterPermissions.appendChild(filterPermissions.render());

            return sectionFilterPermissions;


        } catch (e) {

            error = new Monet.Exception.ReturnError(this,
                'Error on render content container permissions.', e);
            error.console();
        }

    },

    createListGroups: function (data) {

        var error = null,
            list  = null;

        try {

            if (data) {

                list = new Greenmile.GroupPermissions.ListGroup();

                list.createListGroup(data);

            }

        } catch (e) {

            error = new Monet.Exception.ReturnError(this,
                'Error on create list groups.');
            error.console();

        }

    },

    renderSectionTreeViewPermissions: function () {

        var error                  = null,
            sectionListPermissions = null,
            sectionContainer       = null,
            treeViewContainer      = null,
            fragment               = null,
            i18n                   = Monet.I18n,
            contentSection         = '',
            keySectionGroups       = 'Greenmile.GroupPermissions.sectionOfPermissions';

        try {

            fragment = document.createDocumentFragment();

            contentSection = '<h1>' + i18n.getResourcesByKey(keySectionGroups) + '</h1>';

            sectionListPermissions = document.createElement('div');
            sectionListPermissions.id = 'containerListPermissions';

            sectionContainer = document.createElement('div');
            sectionContainer.className = 'form_section_header';
            sectionContainer.insertAdjacentHTML('beforeEnd', contentSection);

            treeViewContainer = document.createElement('div');
            treeViewContainer.id = 'treeView';

            fragment.appendChild(sectionContainer);
            fragment.appendChild(treeViewContainer);

            sectionListPermissions.appendChild(fragment);

            return sectionListPermissions;

        } catch (e) {

            error = new Monet.Exception.ReturnError(this,
                'Error on render section treeview permissions.');
            error.console();

        }
    },

    formAlertError: function () {

        var divError = document.createElement("div");
        divError.setAttribute('class', 'monetInlineAlerContainer');


        return divError;
    },

    renderSidebarContent: function () {

        var error             = null,
            filter            = null,
            list              = null,
            keyLabelFilter    = 'Greenmile.GroupPermissions.filterGroups',
            keyLabelFormatted = '',
            documentFragment  = null;

        try {

            keyLabelFormatted = Monet.I18n.getResourcesByKey(keyLabelFilter);

            documentFragment = document.createDocumentFragment();
            filter = new Greenmile.GroupPermissions.FilterGroups();
            list = new Greenmile.GroupPermissions.ListGroup();

            filter.setId('searchGroups');
            filter.setTextLabel(keyLabelFormatted);

            documentFragment.appendChild(filter.render());
            documentFragment.appendChild(list.createContainerList());

            return documentFragment;

        } catch (e) {

            error = new Monet.Exception.ReturnError(this,
                "Error on create tab group permission");
            error.console();

        }
    },

    renderContainerPermissions: function (groupId) {  

        var error            = null,
            containerParent  = null,
            documentFragment = null,
            tabContainer     = null,
            containerExists  = null,
            tabSelector      = "#GroupPermissions",
            inputGroupId     = null,
            router           = new App.Routers.GroupPermissions();

        try {

            tabContainer = document.querySelector(tabSelector);

            if (tabContainer) {

                containerExists = tabContainer.querySelector('#containerPermissions');

                if (containerExists) {
                    tabContainer.removeChild(containerExists);
                }

                documentFragment = document.createDocumentFragment();

                containerParent = document.createElement('div');
                containerParent.id = 'containerPermissions';

                inputGroupId = document.createElement('input');
                inputGroupId.type = 'hidden';
                inputGroupId.id = 'groupId';
                inputGroupId.value = groupId;

                documentFragment.appendChild(inputGroupId);
                documentFragment.appendChild(this.renderFilterPermissions());
                documentFragment.appendChild(this.formAlertError());
                documentFragment.appendChild(this.renderSectionTreeViewPermissions());

                containerParent.appendChild(documentFragment);
            }

            tabContainer.appendChild(containerParent);
            router.getPermissionsByGroupAndPopulateGrid(groupId);

        } catch (e) {
            error = new Monet.Exception.ReturnError(this,
                'Error on render container permission.');
            error.console();

        }

    },

    createTab: function () {
        
        var error                  = null,
            sidebar                = null,
            tabName                = "GroupPermissions",
            containerSideBar       = null,
            tabContainer           = null,
            screenTabName          = "Greenmile.GroupsPermission.screenTabName",
            tabContainerSelector   = "#GroupPermissions",
            documentFragment       = null,
            routerGroupPermissions = null,
            helper;

        try {

            tabContainer = document.querySelector(tabContainerSelector);

            if (tabContainer) {
                helper = new Monet.UI.Help(tabName, Monet.I18n.getResourcesByKey(screenTabName));
                sidebar = new Monet.UI.Sidebar();
                routerGroupPermissions = new App.Routers.GroupPermissions();
                documentFragment = document.createDocumentFragment();

                containerSideBar = sidebar.render();
                containerSideBar.appendChild(this.renderSidebarContent());
                
                const containerPermissionsParent = this.mountInitialView();
                documentFragment.appendChild(containerPermissionsParent);
                documentFragment.appendChild(containerSideBar);
                documentFragment.appendChild(helper.render());

                tabContainer.appendChild(documentFragment);

                routerGroupPermissions.getGroupsAndCreateList();

            }

        } catch (e) {

            error = new Monet.Exception.ReturnError(this,
                "Error on create tab group permission");
            error.console();
        }


    },

    mountInitialView: function() {
        let containerPermissionsParent = document.createElement('div');
        containerPermissionsParent.setAttribute("id", "containerPermissions");

        let contentPermissionsChildren = document.createElement('div');
        contentPermissionsChildren.setAttribute("class", "containerPermissions__content");

        let contentPermissionsChildrenText = document.createElement('div');
        contentPermissionsChildrenText.innerHTML = Monet.I18n.getResourcesByKey('GroupPermissions.infoToClickGroup');
        contentPermissionsChildrenText.setAttribute("class", "containerPermissions__txt-message");

        let contentPermissionsChildrenImage = document.createElement('div');
        contentPermissionsChildrenImage.setAttribute("class", "containerPermissions__image-svg");

        contentPermissionsChildren.appendChild(contentPermissionsChildrenImage);
        contentPermissionsChildren.appendChild(contentPermissionsChildrenText);

        containerPermissionsParent.appendChild(contentPermissionsChildren);

        return containerPermissionsParent;
    },

    manageTab: function () {
        try {
          this.createTab();
        } catch (e) {
            const error = new Monet.Exception.ReturnError(this,
                "Error on create tab group permission");
            error.console();
        }
    },

    afterErrorUpdate: function (response, callbackForError) {
        var validate = {
            status: true,
            errorMessages: []
        };

        validate.errorMessages.push({
          resource: {
            i18nMessage: Monet.I18n.getResourcesByKey('GroupPermissions.invalidUpdate')
          }
        });
        validate.status = false;

        this.showErrorMessages(validate);

        var treeView = document.querySelector('#GroupPermissions #treeView');
        treeView.style.top = '159px';

        $('#loading_img').hide();
        Monet.Configurations.errorNotification(null, response);

        if (callbackForError) {
            callbackForError();
        }

    },

    afterSuccessUpdate: function () {

        var treeView = document.querySelector('#GroupPermissions #treeView');
        this.removeMessageError();
        treeView.style.top = '';

        $('#loading_img').hide();

    },

    showErrorMessages: function (validate) {

        var monetMessage = new Monet.Form.Messages.InlineMessage();
        monetMessage.setScope("#GroupPermissions");
        monetMessage.setInfoType("error");
        monetMessage.setMessage(validate);
        monetMessage.triggerMessage();
    },

    removeMessageError: function () {

        try {

            var divError = document.querySelector("#GroupPermissions .monetInlineAlerContainer .alert");

            if (divError !== null) {

                var divParent = divError.parentNode;
                divParent.removeChild(divError);

                var treeView = document.querySelector('#GroupPermissions #treeView');
                treeView.style.top = '100px';

            }

        } catch (e) {

            var error = new Monet.Exception.ReturnError(this, "Error on remove message error.");
            error.console();

        }
    },

    beforeAjaxSend: function (result) {

        if (result) {
            $('#loading_img').show();
        }

    }

};
